<template>
  <div>
    <div
      itemtype="https://schema.org/Product"
      itemscope
    >
      <meta
        itemprop="name"
        :content="props.title"
      />
      <link
        itemprop="image"
        :href="seoStore.resizeImage"
      />

      <link
        itemprop="image"
        :href="seoStore.secondExpImage"
      />

      <link
        itemprop="image"
        :href="seoStore.thirdExpImage"
      />
      <!-- картинки-обложки первых трех экскурсий листинга-->

      <meta
        itemprop="description"
        :content="props.description"
      />
      <div
        itemprop="offers"
        itemtype="https://schema.org/AggregateOffer"
        itemscope
      >
        <meta
          itemprop="lowPrice"
          :content="seoStore.lowPrice?.toString()"
        />
        <!--минимальная цена экскурсии листинга-->

        <meta
          itemprop="highPrice"
          :content="seoStore.highPrice?.toString()"
        />
        <!--максимальная цена экскурсии листинга-->

        <meta
          itemprop="offerCount"
          :content="filtersStore.searchTotalCount?.toString()"
        />
        <!--количество экскурсии города/рубрики/локации-->

        <meta
          itemprop="priceCurrency"
          :content="seoStore.priceCurrency"
        />
        <!--валюта оплаты-->
      </div>

      <div
        itemprop="aggregateRating"
        itemtype="https://schema.org/AggregateRating"
        itemscope
      >
        <meta
          itemprop="reviewCount"
          :content="seoStore.reviewCount?.toString()"
        />
        <!--общее количество оценок-->

        <meta
          itemprop="ratingValue"
          :content="seoStore.ratingValue?.toString()"
        />
        <!--средняя оценка-->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useSeoStore } from '@/shared/store/useSeoStore.ts';
  import { useExcursionFiltersStore } from '@/entities/filter/store/excursion';

  interface Props {
    title: string;
    description: string;
  }

  const props = defineProps<Props>();

  const seoStore = useSeoStore();
  const filtersStore = useExcursionFiltersStore();
</script>

<style scoped lang="scss"></style>
